import * as React from 'react';
import { connect } from 'react-redux';

import OrganizationBilling from '../../organizations/components/organization-billing/OrganizationBilling';
import BaseAgencyPage from './BaseAgencyPage';

import { t } from 'utils/language';

import type { Organization, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  currentOrganization: Organization
};

type Props = OwnProps & StateProps;

const AgencyBillingPage = ({
  params,
  currentOrganization
}: Props) => (
  <BaseAgencyPage
    id={Number(params.id)}
    documentTitle={t('agency_billing_page_title')}
    renderChildren={() => (
      <OrganizationBilling
        organizationType="agency"
        currentOrganization={currentOrganization}
      />
    )}
  />
);

const mapStateToProps = ({ organizations }): StateProps => ({
  currentOrganization: organizations.currentOrganization
});

export default connect(mapStateToProps)(AgencyBillingPage);
